// PLOW — which board opens first.
//
// The page holds several boards and a person usually cares about one of
// them: the one their own name is on. So the default is the most relevant
// board rather than the first alphabetically. A board they opened
// deliberately last time wins over the ranking, and a board named by the URL
// (a notification link) wins over everything, provided it is in the list.
//
// Plain functions over the GET /plows rows, so the choice is testable
// without rendering the page.

const RANK = { member: 3, editor: 2, viewer: 1 };

/** How much this board matters to the person: on it, edits it, views it, or none. */
export function plowRelevance(plow) {
  return RANK[plow?.my_level] || 0;
}

/**
 * The id of the board to open, or null when there are none.
 * @param {Array<{id: string, name?: string, my_level?: string|null}>|null} plows
 * @param {{ requested?: string|null, remembered?: string|null }} [prefs]
 */
export function pickDefaultPlow(plows, { requested = null, remembered = null } = {}) {
  const list = Array.isArray(plows) ? plows : [];
  if (!list.length) return null;
  if (requested && list.some(p => p.id === requested)) return requested;
  if (remembered && list.some(p => p.id === remembered)) return remembered;
  const sorted = [...list].sort((a, b) =>
    (plowRelevance(b) - plowRelevance(a)) || String(a.name || '').localeCompare(String(b.name || '')));
  return sorted[0].id;
}
